export default {"src":"/_next/static/media/illustration-horse-meat.7a63e689.svg","height":98,"width":70};